import request from "@/util/http";

/**
 * 检查用户名是否合法
 */
export function check_username(params) {
	return request({
		url: '/upms/shop/message/check_username',
		method: 'get',
		params: params,
	})
}


/**
 * 发送
 */
export function send(params) {
	return request({
		url: '/upms/shop/message/send',
		method: 'get',
		params: params,
	})
}



/**
 * 发送
 */
export function send_entity(params) {
	return request({
		url: '/upms/shop/message/send_entity',
		method: 'post',
		params: params,
	})
}


/**
 * 查看
 */
export function view(params) {
	return request({
		url: '/upms/shop/message/view',
		method: 'get',
		params: params,
	})
}


/**
 * 回复
 */
export function reply(params) {
	return request({
		url: '/upms/shop/message/reply',
		method: 'post',
		params: params,
	})
}


// module.exports = {
// 	check_username,
// 	send,
// 	send_entity,
// 	view,
// 	reply,
// }
